const mutations = {
  setApprovalData(state, payload) {
    state.workflowApprovalData = payload;
  },
};

export default mutations;
